import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { ApolloClient, ApolloClientOptions, NormalizedCacheObject, setLogVerbosity } from '@apollo/client';
import { makeCache } from '~/apollo/cache';
import typeDefs from './client-schema.gql';
import { getLinkChain } from './link';

const cachedClients: Partial<Record<'debug' | 'standard', ApolloClient<NormalizedCacheObject>>> = {};

export function getClient( withDebug: boolean = false ) {
  if ( process.env.NODE_ENV === 'development' ) {
    setLogVerbosity( 'debug' );
    loadDevMessages();
    loadErrorMessages();
  }

  const cacheKey = withDebug ? 'debug' : 'standard';

  const fromCache = cachedClients[cacheKey];

  if ( fromCache ) {
    return fromCache;
  } else {
    const clientOptions: ApolloClientOptions<NormalizedCacheObject> = {
      link: getLinkChain( withDebug ),
      cache: makeCache(),
      typeDefs,
    };
    
    if ( withDebug ) {
      // I'm not sure why, bug the __operationLog key injected by `debugLink` above is stripped
      // out by Apollo before reaching the front-end, unless we use a no-cache policy. Maybe there's a
      // better way? It seems funny.
      clientOptions.defaultOptions = {
        query: { fetchPolicy: 'no-cache' },
        mutate: { fetchPolicy: 'no-cache' },
        watchQuery: { fetchPolicy: 'no-cache' },
      };
    }

    const newClient = new ApolloClient( clientOptions );
    cachedClients[cacheKey] = newClient;

    return newClient;
  }
}
